"use client";

import { c as _c } from "react/compiler-runtime";
import { Geist_Mono, Inter } from "next/font/google";
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
const sans = Inter({
  weight: "variable",
  subsets: ["latin"],
  variable: "--font-sans",
  display: "swap"
});
const mono = Geist_Mono({
  weight: "variable",
  subsets: ["latin"],
  variable: "--font-mono",
  display: "swap"
});
export default function GlobalError(t0) {
  const $ = _c(19);
  const {
    error,
    reset
  } = t0;
  const log = Sentry.logger;
  let t1;
  let t2;
  if ($[0] !== error) {
    t1 = () => {
      log.error("Error processing request", {
        error
      });
      Sentry.captureException(error);
      console.error("Error processing request", error);
    };
    t2 = [error, log];
    $[0] = error;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== error.digest) {
    t3 = <p className="text-base font-semibold text-slate-11">{error.digest}</p>;
    $[3] = error.digest;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = error?.name ?? "Something went wrong \uD83D\uDE2D";
  let t5;
  if ($[5] !== t4) {
    t5 = <h1 className="animate-fade-in relative text-balance bg-gradient-to-br from-slate-12 to-slate-11 bg-clip-text text-[clamp(40px,5vw,76px)] font-black leading-tight text-transparent [max-inline-size:19ch]">{t4}</h1>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = error?.message ?? "Sorry, something went wrong while trying to process your request.";
  let t7;
  if ($[7] !== t6) {
    t7 = <p className="mt-6 max-w-xl text-base leading-7 text-slate-11">{t6}</p>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== reset) {
    t8 = <Button onClick={() => reset()}>Try again</Button>;
    $[9] = reset;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <a href="mailto:support@fluentgroup.com.au" className="leading-none tracking-wide text-blue-11 underline-offset-4 hover:underline active:underline-offset-[6px]">Contact support <span aria-hidden="true">→</span></a>;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t8) {
    t10 = <div className="mt-10 flex items-center justify-center gap-x-6">{t8}{t9}</div>;
    $[12] = t8;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t3 || $[16] !== t5 || $[17] !== t7) {
    t11 = <html lang="en" suppressHydrationWarning={true} className={`h-full ${sans.variable} ${mono.variable}`}><body className="h-full w-full bg-white text-base/6 font-normal text-slate-12 [--max-page-width:64rem] [--page-padding-default:_24px] [--page-padding-left:_max(env(safe-area-inset-left),var(--page-padding-default))] [--page-padding-right:_max(env(safe-area-inset-right),var(--page-padding-default))] dark:bg-black sm:[--page-padding-default:_32px]"><main className="min-h-safe grid place-items-center px-6 py-24 sm:py-32 lg:px-8"><div className="grid place-items-center text-center">{t3}{t5}{t7}{t10}</div></main></body></html>;
    $[14] = t10;
    $[15] = t3;
    $[16] = t5;
    $[17] = t7;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
}